import { withToken, axiosInstanceV1 } from "@rentablo/api";
import {
  CreateAccountHolderParams,
  AccountHolder,
  UpdateAccountHolderParams,
  PageableAccountHolderList,
} from "@api/v1/model";

export const createAccountHolder = async (
  token: string | undefined | undefined,
  attrs: CreateAccountHolderParams
) => {
  const { data } = await axiosInstanceV1.post<AccountHolder>(
    `/accountHolders`,
    attrs,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const updateAccountHolder = async (
  token: string | undefined | undefined,
  { id, ...attrs }: UpdateAccountHolderParams
) => {
  const { data } = await axiosInstanceV1.put<AccountHolder>(
    `/accountHolders/${id}`,
    attrs,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const loadAccountHolder = async (
  token: string | undefined,
  id: number
) => {
  const response = await axiosInstanceV1.get<AccountHolder>(
    `/accountHolders/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const loadAccountHolders = async (
  token: string | undefined,
  params: GetAccountHoldersParams
) => {
  const { data } = await axiosInstanceV1.get<PageableAccountHolderList>(
    `/accountHolders`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    }
  );

  return data;
};

export interface GetAccountHoldersParams {
  /**
   * A custom search string; retrieves account holders matching<br>
   *                         - the natural persons name(s)<br>
   *                         - the external ID<br>
   *                         - the bank accounts IBAN<br>
   *                         - the email address of the underlying user<br>
   *                         - the given depot identifier (Like search)<br>
   */
  search?: string;
  /** Retrieve the given account holders */
  id?: number[];
  /** Retrieve account holders for the given user(s) */
  userId?: number[];
  /** Retrieve account holders having the given external IDs */
  externalId?: string[];
  /** Retrieve account holders having the given types */
  type?: ("PRIVATE" | "COMPANY")[];
  /** Retrieve account holders having / not having an external ID; default is to ignore the parameter */
  externalIdAssigned?: boolean;
  /** Result page that you want to retrieve. */
  page?: number;
  /** Maximum number of records per page. Can be at most 500. NOTE: Due to its validation                              and visualization, the swagger frontend might show very low performance, or even crashes,                              when a service responds with a lot of data. It is recommended to use a HTTP client like                              Postman or DHC instead of our swagger frontend for service calls with large page sizes. */
  perPage?: number;
  /** Determines the order of the results. Allowed params: id, externalId, externalIdAssigned.                              The default order for all services is 'id asc'. */
  order?: string;
}

export const updateAccountHoldersWithToken = withToken(updateAccountHolder);
export const getAccountHoldersWithToken = withToken(loadAccountHolders);
